// extracted by mini-css-extract-plugin
export default {"container":"urb_2LJMq","logo":"urb_log_1GBNI"};